import Tone from 'tone';
import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';

const ROOT = 1.5;
const height = HEIGHT;
const width = WIDTH;
const padding = PADDING;

export default superclass => class extends superclass  {
    getCoordinates(width=WIDTH, height=HEIGHT, padding=PADDING) {
        let value = this.toSeconds ? this.toSeconds(true) : this.getNumber(true);
        let depth = this.depth;
        let dMin = this.depthParameter ? this.depthParameter.min : 0;
        let dMax = this.depthParameter ? this.depthParameter.max : 1;
        depth = (depth - dMin) / (dMax - dMin);
        value = (value - this.min) / (this.max - this.min);
        let x = padding + width * Math.pow(Math.max(0,value), 1.0/ROOT);
        let y = height - height * Math.pow(Math.max(0, depth), 1.0/ ROOT) - padding;
        return {
            x: Math.min(width - padding, x),
            y: Math.max(padding, y)
        };
    }

    fromCoordinates(x,y) {
        let original = Math.max(0, (height - (y + padding)) / height);
        let dMin = this.depthParameter ? this.depthParameter.min : 0;
        let dMax = this.depthParameter ? this.depthParameter.max : 1;
        let depth = dMin + (dMax - dMin) * Math.pow(Math.max(0, (height - (y)) / height), ROOT);
        let value = this.min + (this.max - this.min) * Math.pow((x) / (width ), ROOT);
        return {value, depth};
    };

    setCoordinates(x, y, time, rampTime, automation=false) {
        let original = Math.max(0, (height - (y + padding)) / height);
        let dMin = this.depthParameter ? this.depthParameter.min : 0;
        let dMax = this.depthParameter ? this.depthParameter.max : 1;
        let depth = dMin + (dMax - dMin) * Math.pow(Math.max(0, (height - (y + padding)) / height), ROOT);
        if (depth < 0 || depth > 1) {
            return {id: -1, value: -1};
        }
        let value = this.min + (this.max - this.min) * Math.pow((x - padding) / (width ), ROOT);

        if (value >= this.max || value <= this.min) {
            return {value: -1, id: -1};
        }

        if (isNaN(value) || isNaN(depth)) {
            // we dont fuck with NaNs
            return {id: -1, value: -1};
        }
        this._depth = depth;
        if (this.depthParameter) {
            this.depthParameter.set(depth, automation, true, time, rampTime);
        } 
        return this.set(value, automation, true, time, rampTime);
    }

    moveCoordinates(xDiff, yDiff, automation=this.isRecording, rampTime=0.1) {
        let {x,y} = this.getCoordinates();
        x += xDiff;
        y += yDiff;
      

        // now with this we need to calculate the new depth and value
        // automation = true because we dont want to accidently cause automations here
        return this.setCoordinates(x,y,Tone.Master.context.currentTime, rampTime, automation);
    }

    unmap() {
        if (this.isMapped) {
            this.isMapped.unmapParameter(this.isMapped._parameters.indexOf(this));
            if (this.depthParameter) {
                this.depthParameter.set(1, true, true);
            }
        }
    }
}
